import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DsBoxModule,
  DsButtonModule,
  DsIconModule,
  DsMessageModule,
  DsModalModule,
  DsProgressBarModule,
  DsSelectModule,
} from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { LoadingIndicatorComponent } from '../../../loading/loading-indicator.component';
import { CustomerInsightsBoxComponent } from './customer-insights-box/customer-insights-box.component';
import { InsightsViewModel } from './model/insights.view-model';
import { NextBestVehicleComponent } from './next-best-vehicle/next-best-vehicle.component';

@Component({
  selector: 'cdf-customer-insights',
  imports: [
    DsProgressBarModule,
    DsMessageModule,
    DsIconModule,
    DsBoxModule,
    LoadingIndicatorComponent,
    DsButtonModule,
    DsModalModule,
    CustomerInsightsBoxComponent,
    NextBestVehicleComponent,
    DsSelectModule,
    FormsModule,
  ],
  template: `
    @if (insights(); as insights) {
      <ds-box elevation="base">
        <ds-box-content>
          <ds-select
            [isFilterable]="false"
            [(ngModel)]="brandSelection"
            [disabled]="insights.selectionDisabled"
            [options]="[
              { id: 'BMW', label: 'BMW' },
              { id: 'MINI', label: 'MINI' },
            ]"
          />

          <div class="customer-data-grid">
            @if (insights.customerValueClass !== undefined) {
              <cdf-customer-insights-box
                [title]="i18n('customerInsights.customerValue')"
                [info]="i18n('customerInsights.info.customerValue')"
                [percentage]="{ value: insights.customerValueClass, maxValue: 5, icon: 'heart' }"
              />
            }
            @if (insights.purchaseScoreClass !== undefined) {
              <cdf-customer-insights-box
                [title]="i18n('customerInsights.purchaseScore')"
                [info]="i18n('customerInsights.info.purchaseScore')"
                [percentage]="{ value: insights.purchaseScoreClass, maxValue: 20, icon: 'shopping_bag' }"
              />
            }
            @if (insights.bevScoreClass !== undefined) {
              <cdf-customer-insights-box
                [title]="i18n('customerInsights.bevScoreClass')"
                [info]="i18n('customerInsights.info.bevScoreClass')"
                [percentage]="{ value: insights.bevScoreClass, maxValue: 20, icon: 'charging_electric' }"
              />
            }
            @if (insights.nextBestVehicles.length > 0) {
              <cdf-customer-insights-box
                [title]="i18n('customerInsights.nextBestVehicle')"
                [info]="i18n('customerInsights.info.nextBestVehicle')"
              >
                <cdf-next-best-vehicle [vehicles]="insights.nextBestVehicles" imageOnly />
              </cdf-customer-insights-box>
            }
          </div>
        </ds-box-content>
      </ds-box>
    } @else if (loading()) {
      <cdf-loading-indicator>{{ i18n('profile.loading') }}</cdf-loading-indicator>
    } @else if (insights() === undefined) {
      <ds-message [messageText]="i18n('customerInsights.noInsightsAvailable')" [isDismissable]="false" tone="info" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './customer-insights.component.scss',
})
export class CustomerInsightsComponent {
  readonly i18n = useI18n();

  readonly insights = input.required<InsightsViewModel | undefined>();
  readonly loading = input(false);
  readonly brandSelection = model.required<'BMW' | 'MINI'>();
}
